import { ReactNode, useState } from 'react';
import Sidebar from './Sidebar';
import Topbar from './Topbar';

interface AppLayoutProps {
	children: ReactNode;
	topbarContent?: ReactNode;
	showTopbar?: boolean;
}

const AppLayout = ({ children, topbarContent, showTopbar = true }: AppLayoutProps) => {
	const [isSidebarOpen, setIsSidebarOpen] = useState(false);

	const toggleSidebar = () => {
		setIsSidebarOpen(!isSidebarOpen);
	};

	const closeSidebar = () => {
		setIsSidebarOpen(false);
	};

	return (
		<div className="flex min-h-screen bg-white dark:bg-gray-900 transition-colors duration-300">
			{/* Sidebar - no overlay needed */}
			<Sidebar isOpen={isSidebarOpen} onClose={closeSidebar} />

			{/* Main content */}
			<div className="flex-1 flex flex-col min-w-0">
				{showTopbar && (
					<Topbar onMenuClick={toggleSidebar}>
						{topbarContent}
					</Topbar>
				)}
				<div className="flex-1 p-4 md:p-6 lg:p-8">{children}</div>
			</div>
		</div>
	);
};

export default AppLayout;
